import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PASystem from './pages/PASystem';
import AcousticSolutions from './pages/AcousticSolutions';
import TrainingService from './pages/TrainingService';
import Brands from './pages/Brands';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Consultancy from './pages/Consultancy';
import Blog from './pages/Blog';
import NewArrivals from './pages/NewArrivals';
import SystemPlanner from './pages/SystemPlanner';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services/pa-system" element={<PASystem />} />
            <Route path="/services/acoustic-solutions" element={<AcousticSolutions />} />
            <Route path="/services/training-service" element={<TrainingService />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/consultancy" element={<Consultancy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new-arrivals" element={<NewArrivals />} />
            <Route path="/system-planner" element={<SystemPlanner />} />
                        <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;
